<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <div class="flex -mx-2 text-4xl font-bold">
        <router-link to="/af/maler" class="px-4 text-red-400">Maler</router-link>
        <router-link to="/af/meldingslogg" class="px-4 text-red-500"><div class="border-b-2 border-red-500">Meldingslogg</div></router-link>
        <router-link to="/af/smslogg" class="px-4 text-red-400">SMS logg</router-link>
      </div>
    </div>
    <panel>
      <data-table
        :headers="headers"
        :items="messages"
        @click="onClick">
      </data-table>
    </panel>
    <modal header="Melding" v-if="selected" @close="selected = null">
      <div class="text-sm uppercase font-bold text-gray-500">Sendt</div>
      <div>{{ selected.createdOnDisplay }}</div>

      <div class="text-sm uppercase font-bold text-gray-500 mt-6">Emne</div>
      <div>{{ selected.subject }}</div>

      <div class="text-sm uppercase font-bold text-gray-500 mt-6">Innhold</div>
      <div v-html="selected.body"></div>

      <div class="text-sm uppercase font-bold text-gray-500 mt-6">Mottakere</div>
      <div class="relative flex items-center w-48 mt-4">
        <font-awesome-icon class="absolute" :icon="['far', 'search']" size="sm" />
        <input class="pl-6 w-full border-0 py-0 border-b-2 border-gray-400 rounded-none bg-white focus:bg-white" type="text" v-model="userFilter" />
        <font-awesome-icon class="absolute right-0" :icon="['far', 'times']" @click="userFilter = ''" v-if="userFilter != ''" />
      </div>
      <div class="mt-2" v-if="filteredUsers.length > 0">
        <div v-for="(user, index) in filteredUsers" :key="index">
          {{ user.name }} <span class="text-gray-500">&lt;{{ user.email }}&gt;</span>
        </div>
      </div>
      <div class="italic mt-2" v-else>
        Ingen mottakere matcher <span class="font-bold">{{ userFilter }}</span>.
      </div>
    </modal>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
export default {
  name: 'message-list',
  data () {
    return {
      selected: null,
      userFilter: '',
      headers: [
        { text: 'Dato', align: 'left', nowrap: true, value: 'createdOnDisplay' },
        { text: 'Emne', align: 'left', value: 'subject' },
        { text: 'Antall mottakere', align: 'left', value: 'recipientCount' },
      ],
      messages: [],
    }
  },
  computed: {
    filteredUsers () {
      if (!this.selected)
        return []

      return _.filter(this.selected.users, u =>
        `${u.name} ${u.email}`.toLowerCase().indexOf(this.userFilter.toLowerCase()) >= 0
        )
    }
  },
  methods: {
    async onClick (emailMessage) {
      this.selected = await api.af.getMessage(emailMessage.emailMessageId)
    }
  },
  async created () {
    this.messages = await api.af.getMessages(0, 25)
  }

}
</script>